<template>
  <!-- main nav container -->
  <div class="navbar" id="nav">
    <div class="nav-logo" id="myNav-logo">
      <!-- logo -->
      <a href="#">
        <img
          src="../img/image 21.png"
          alt="logo1"
          width="160px"
          v-on:click="routeToHome()"
        />
      </a>
      <!-- burger-icon (mobile)-->
      <a href="javascript:void(0);" class="icon" v-on:click="navResponsive()">
        <img src="../img/NLC new website/burger.png" alt="" />
      </a>
    </div>
    <!-- nav links: general, check login status -->
    <div v-if="$route.name != 'fieldTrial'" class="nav-links" id="myNav-links">
      <router-link @click="routeToHome()" to="/providers">{{
        $t("Header[0]")
      }}</router-link>
      <router-link @click="routeToHome()" to="/schools">{{
        $t("Header[1]")
      }}</router-link>
      <router-link @click="routeToHome()" to="/technology">{{
        $t("Header[2]")
      }}</router-link>
      <!-- <router-link to="/#SolutionContainer">{{ $t("Header[3]") }}</router-link> -->
      <router-link @click="routeToHome()" to="/whyneuroLeap">{{
        $t("Header[4]")
      }}</router-link>
      <router-link @click="routeToHome()" to="/about">{{
        $t("Header[5]")
      }}</router-link>
      <!-- <router-link @click="routeToHome()" to="/contact">{{
        $t("Header[6]")
      }}</router-link> -->
      <router-link
        v-if="loggedInAdmin"
        @click="routeToHome()"
        :to="{ path: '/userManagement' }"
      >
        {{ $t("Header[7]") }}
      </router-link>
      <router-link
        v-if="loggedInParticipant"
        @click="routeToHome()"
        :to="{ path: '/registeredEvents' }"
      >
        Registered Events
      </router-link>
    </div>
    <!-- nav links: field trial -->
    <div v-else class="nav-links" id="myNav-links">
      <a href="#questionnaireform">{{ $t("Header[12]") }}</a>
      <a href="#fieldTrialVideo">{{ $t("Header[13]") }}</a>
      <a href="#fieldTrialInfo">{{ $t("Header[14]") }}</a>
      <a href="#fieldtrialform">{{ $t("Header[15]") }}</a>
    </div>
    <!-- accessibility -->
    <div class="nav-access dropdown" id="myNav-access">
      <a href="javascript:void(0);" v-on:click="toggleAccessibility()">
        <img
          src="../img/accessibilityicons/ri_accessibility-fill.png"
          alt="access"
          class="dropbtn"
          width="50px"
        />
      </a>
      <br />
      <div class="dropdown_content" id="myDropdown">
        <a href="javascript:void(0);" v-on:click="toggleContent('contrast')">
          <img
            src="../img/accessibilityicons/contrast_png.png"
            alt="contrast"
            class="dropbtn"
            width="40px"
          />
        </a>
        <div class="dropdown_content_contrast nowrap" id="myDropdown_contrast">
          <button
            v-on:click="
              setColor('BW');
              changeColor('BW');
            "
          >
            B&W
          </button>
          <button
            v-on:click="
              setColor('BY');
              changeColor('BY');
            "
          >
            B&Y
          </button>
          <button
            v-on:click="
              setColor('WB');
              changeColor('WB');
            "
          >
            W&B
          </button>
        </div>

        <a
          href="javascript:void(0);"
          v-on:click="toggleContent('read')"
          id="access_read"
        >
          <img
            src="../img/accessibilityicons/Easy Read_png.png"
            alt="easy_read"
            class="dropbtn"
            width="40px"
          />
        </a>
        <div class="dropdown_content_read nowrap" id="myDropdown_read">
          To be update
        </div>

        <a
          href="javascript:void(0);"
          v-on:click="toggleContent('hear')"
          id="access_hear"
        >
          <img
            src="../img/accessibilityicons/hear_png.png"
            alt="hear"
            class="dropbtn"
            width="40px"
          />
        </a>
        <div class="dropdown_content_hear nowrap" id="myDropdown_hear">
          To be update
        </div>
      </div>
    </div>
    <!-- language -->
    <select
      v-model="$i18n.locale"
      class="nav-btn btn-language"
      id="btn-language"
    >
      <option
        v-for="(lang, i) in $i18n.availableLocales"
        :key="`Lang${i}`"
        :value="lang"
        class="btn-option"
      >
        {{ lang }}
        <span v-if="i == 0">/ عربي</span>
        <span v-else-if="i == 1">/ 中文简体</span>
        <span v-else-if="i == 2">/ 中文繁体</span>
        <span v-else-if="i == 3"></span>
        <span v-else-if="i == 4">/ Français</span>
        <span v-else-if="i == 5">/ Deutsch</span>
        <span v-else-if="i == 6">/ 日本語</span>
        <span v-else-if="i == 7">/ 한국인</span>
        <span v-else-if="i == 8">/ Português</span>
        <span v-else-if="i == 9">/ русский</span>
        <span v-else-if="i == 10">/ Española</span>
        <span v-else-if="i == 11">/ Svenska</span>
        <span v-else-if="i == 12">/ Tiếng Việt</span>
      </option>
    </select>
    <!-- nav special links -->
    <div class="nav-btns" id="myNav-btns">
      <!-- login -->
      <span v-if="!loggedIn">
        <router-link to="/login">
          <button class="nav-btn btn-login">
            {{ $t("Header[10]") }}
          </button>
        </router-link>
      </span>
      <!-- log out -->
      <span v-else>
        <button @click="logout" class="nav-btn btn-login">
          {{ $t("Header[11]") }}
        </button>
      </span>
      <!-- sign up -->
      <span>
        <router-link to="/register">
          <button type="button" class="nav-btn btn-signup">
            {{ $t("authentication.register") }}
          </button>
        </router-link>
      </span>
    </div>
  </div>
</template>

<script>
// import { EventBus } from "../bus";

// when click on places other than access icons, access content will be cleared
window.onclick = function (event) {
  if (!event.target.matches(".dropbtn")) {
    var dropdowns_contrast = document.getElementsByClassName(
      "dropdown_content_contrast"
    );
    var dropdowns_read = document.getElementsByClassName(
      "dropdown_content_read"
    );
    var dropdowns_hear = document.getElementsByClassName(
      "dropdown_content_hear"
    );
    var dropdowns_language = document.getElementsByClassName(
      "dropdown_content_language"
    );
    var dropdowns = document.getElementsByClassName("dropdown_content");

    for (var i = 0; i < dropdowns_contrast.length; i++) {
      if (dropdowns_contrast[i].classList.contains("show")) {
        dropdowns_contrast[i].classList.remove("show");
      }
    }
    for (i = 0; i < dropdowns_read.length; i++) {
      if (dropdowns_read[i].classList.contains("show")) {
        dropdowns_read[i].classList.remove("show");
      }
    }
    for (i = 0; i < dropdowns_hear.length; i++) {
      if (dropdowns_hear[i].classList.contains("show")) {
        dropdowns_hear[i].classList.remove("show");
      }
    }
    for (i = 0; i < dropdowns_language.length; i++) {
      if (dropdowns_language[i].classList.contains("show")) {
        dropdowns_language[i].classList.remove("show");
      }
    }
    for (i = 0; i < dropdowns.length; i++) {
      if (dropdowns[i].classList.contains("show")) {
        dropdowns[i].classList.remove("show");
      }
    }
  }
};
export default {
  //props: ['username'],
  data() {
    return {
      color: "BW",
    };
  },
  mounted() {
    if (this.$route.hash) {
      this.$nextTick(() => {
        const el = document.querySelector(this.$route.hash);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      });
    }
  },

  props: {
    username: {
      type: String,
      default: "username",
    },
  },

  computed: {
    loggedIn() {
      var logged = this.$store.getters.isLoggedIn;
      return logged;
    },
    loggedInAdmin() {
      var logged = this.$store.getters.isLoggedIn;
      var role = this.$store.getters.getUserLevel;
      return logged && role == "Admin";
    },
    loggedInParticipant() {
      var event = this.$store.getters.getEventID;
      return event != null;
    },
  },
  watch: {
    $route() {
      this.setColor(this.color);
      this.changeColor(this.color);
      this.navResponsive();
    },
  },
  methods: {
    logout() {
      this.$store.commit("setAuthUser", null);
      this.$store.commit("setAuthUser", null);
      this.$store.commit("setEventID", null);
      this.$store.commit("setUserLevel", null);

      if (this.$route.name != "App") {
        this.$router.push("/");
      }
    },
    // when burger-icon of mobile nav is clicked, add ".responsive" to logo, links and button classes
    // allows to style elements differently when mobile screen
    navResponsive: function () {
      // nav-logo
      var x = document.getElementById("myNav-logo");
      if (x.className === "nav-logo") {
        x.className += " responsive";
      } else {
        x.className = "nav-logo";
      }
      // nav-links
      var y = document.getElementById("myNav-links");
      if (y.className === "nav-links") {
        y.className += " responsive";
      } else {
        y.className = "nav-links";
      }
      // nav-buttons
      var z = document.getElementById("myNav-btns");
      if (z.className === "nav-btns") {
        z.className += " responsive";
      } else {
        z.className = "nav-btns";
      }

      // nav-access
      var access = document.getElementById("myNav-access");
      if (access.className === "nav-access dropdown") {
        access.className += " responsive";
      } else {
        access.className = "nav-access dropdown";
      }
      // language
      var lan = document.getElementById("btn-language");
      if (lan.className === "nav-btn btn-language") {
        lan.className += " responsive";
      } else {
        lan.className = "nav-btn btn-language";
      }
    },
    routeToHome: function () {
      if (this.$route.path !== "/") {
        this.$router.push({
          path: "/",
          query: { reload: new Date().getTime() },
        });
      }
    },

    hideNavAndScroll: function () {
      window.scrollTo(0, 0);
    },
    comboFunction: function () {
      this.routeToHome();
    },
    toggleAccessibility: function () {
      document.getElementById("myDropdown").classList.toggle("show");
    },
    toggleContent: function (type) {
      if (type == "contrast") {
        document.getElementById("myDropdown_contrast").classList.toggle("show");
        this.clearOther(type);
      } else if (type == "read") {
        document.getElementById("myDropdown_read").classList.toggle("show");
        this.clearOther(type);
      } else if (type == "hear") {
        document.getElementById("myDropdown_hear").classList.toggle("show");
        this.clearOther(type);
      } else if (type == "language") {
        document.getElementById("myDropdown_language").classList.toggle("show");
        this.clearOther(type);
      } else {
        return;
      }
    },
    clearOther: function (type) {
      // types must matches ids
      var types = ["contrast", "read", "hear"];
      var ids = ["myDropdown_contrast", "myDropdown_read", "myDropdown_hear"];
      for (var i = 0; i < types.length; i++) {
        if (types[i] == type) {
          continue;
        } else {
          document.getElementById(ids[i]).classList.toggle("show", false);
        }
      }
    },
    setColor(type) {
      this.color = type;
    },

    changeColor: function (type) {
      var FG, BG;
      if (type == "BW") {
        FG = "black";
        BG = "white";
      } else if (type == "BY") {
        FG = "black";
        BG = "yellow";
      } else if (type == "WB") {
        FG = "white";
        BG = "black";
      }
      // background
      document.body.style.backgroundColor = BG;
      // foreground
      document.body.style.color = FG;

      this.extraColorChange(type);
    },
    extraColorChange: function (type) {
      var txtColor, bgColor;
      if (type == "WB") {
        txtColor = "white";
        bgColor = "black";
      } else if (type == "BW") {
        txtColor = "black";
        bgColor = "white";
      } else {
        txtColor = "black";
        bgColor = "yellow";
      }

      if (this.$route.path == "/") {
        // change about us txt bgcolor
        document.getElementById("about-text").style.backgroundColor = bgColor;

        // change problems txt color
        var problems = document.getElementsByClassName("txt-black");
        for (var i = 0; i < problems.length; i++) {
          problems[i].style.color = txtColor;
        }

        // change partner side color
        document.getElementById("partner").style.backgroundColor = bgColor;

        // contactus
        document.getElementById("container_contact").style.backgroundColor =
          bgColor;
        var media = document.getElementsByClassName("media_name");
        for (var j = 0; j < media.length; j++) {
          media[j].style.color = txtColor;
        }

        // media
        var media_icon = document.getElementsByClassName("icon_socialmedia");
        for (var m = 0; m < media_icon.length; m++) {
          media_icon[m].style.backgroundColor = "white";
        }

        // footer
        var footer = document.getElementsByClassName("footer-list-link");
        for (var k = 0; k < footer.length; k++) {
          footer[k].style.color = txtColor;
        }

        // products
        document.getElementById("vueperslides").style.backgroundColor = "white";
        var collapsible = document.getElementsByClassName("card");
        for (var l = 0; l < collapsible.length; l++) {
          collapsible[l].style.backgroundColor = bgColor;
        }
      } else if (this.$route.path == "/fieldTrial") {
        // change about us txt bgcolor
        document.getElementById("about-text").style.backgroundColor = bgColor;
        // footer
        footer = document.getElementsByClassName("footer-list-link");
        for (k = 0; k < footer.length; k++) {
          footer[k].style.color = txtColor;
        }
        // fieldtrail questionnaire
        document.getElementById("fieldtrail_questions").style.color = txtColor;
      }

      // console.log(this.color);
    },
  },
  // hide mobile nav when nav-element has been clicked (hide content / elements, show only navbar)
  // hideNavResponsive: function () {
  //   // nav-logo
  //   var x = document.getElementById("myNav-logo");
  //   x.className = "nav-logo";
  //   // nav-links
  //   var y = document.getElementById("myNav-links");
  //   y.className = "nav-links";
  //   // nav-buttons
  //   var z = document.getElementById("myNav-btns");
  //   z.className = "nav-btns";
  //   // nav-access
  //   var access = document.getElementById("myNav-access");
  //   access.className = "nav-access dropdown";
  //   // emit nav-change to global EventBus, will be caught by Slider and slide content will be updated (for language change)
  //   EventBus.$emit("nav-change");
  // },
};
</script>

<style scoped>
/* MAIN CONTAINERS */
/* | nav-logo |    | nav-links |    | nav-btns | */
.navbar {
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: rgba(255, 255, 255, 0);
  position: absolute;
  z-index: 10;
  text-align: center;
  /* border: 1px solid #dcdfe6; */
}

.nav-logo {
  width: auto;
  float: left;
  display: block;
  margin-left: 5px;
}

.nav-links {
  display: inline-block;
  margin: 0 auto;
  text-decoration-color: #bd4594;
}

.nav-btns {
  float: right;
}

.nav-access {
  float: right;
}

/* Elements inside the containers */
.nav-links a {
  color: black;
  text-align: center;
  padding-left: 60px;
  padding-right: 60px;
  padding-bottom: 8px;
  padding-top: 8px;
  text-decoration: none;
  font-size: 20px;
}

.nav-btn {
  font-size: 20px;
  margin-right: 5px;
  margin-left: 5px;
  padding: 8px 8px;
  cursor: pointer;
  border: none;
  border-radius: 4px;
}

/* Button classes */
.btn-login {
  color: white;
  background-color: #dc6803;
}
.btn-signup {
  background-color: #fcfcec;
  color: #965f17;
}

.btn-donate {
  color: white;
  background-color: #dc6803;
}

.btn-field {
  color: white;
  background-color: #dc6803;
}

.btn-language {
  color: black;
  background-color: white;
  border: 1px solid grey;
}

.btn-option {
  background-color: grey;
  color: white;
}

.dropdown_content {
  display: none;
  position: absolute;
  background-color: white;
}

.dropdown_content_contrast {
  display: none;
  position: absolute;
  border-left: 3px solid black;
  border-right: 3px solid black;
  left: -160px;
  top: 7px;
}

.dropdown_content_read {
  display: none;
  position: absolute;
  border-left: 3px solid black;
  border-right: 3px solid black;
  left: -130px;
  top: 50px;
}

.dropdown_content_hear {
  display: none;
  position: absolute;
  border-left: 3px solid black;
  border-right: 3px solid black;
  left: -130px;
  top: 90px;
}

.dropdown_content_language {
  display: none;
  position: absolute;
  border-left: 3px solid black;
  border-right: 3px solid black;
  left: -130px;
  top: 130px;
}

/* keep content at same line */
.nowrap {
  white-space: nowrap;
}

/* make toggle work */
.show {
  display: block;
}

/* Change the color of links on hover */
.nav-links a:hover {
  background-color: #ddd;
  color: black;
}

/* Hide the link (burger icon) of mobile nav when it is not a small screen */
.nav-logo .icon {
  display: none;
}

/* Make nav elements a bit smaller after 1080 px to not make it overlap, provides still normal nav on most tablets */
@media screen and (max-width: 1080px) {
  .nav-links a {
    font-size: 13px;
    padding-left: 10px;
    padding-right: 10px;
  }

  .nav-btns .nav-btn {
    font-size: 13px;
    padding: 10px;
    margin-top: 10px;
  }
}

/* When the screen is less than 860 pixels wide, hide all links and buttons. Show the link (burger icon) that should be used as mobile navigation */
@media screen and (max-width: 860px) {
  .nav-links {
    display: none;
  }

  .nav-btns {
    display: none;
  }
  /* .btn-language {
    display: none;
  } */

  /* .nav-access {
    display: none;
  } */

  .nav-logo {
    display: block;
  }

  .nav-logo .icon {
    display: block;
    position: absolute;
    right: 0;
    top: 0;
    padding-right: 14px;
    padding-top: 16px;
    color: grey;
  }

  #myNav-access {
    /* margin-left: 30vw; */
    margin-right: 1vw;
  }
}

/* The "responsive" class is added to the nav-elements with JavaScript function "navResponsive() when the user clicks on the burger icon. These classes make the elements display vertically instead of horizontally on small screens makes the nav-links look good on small screens */
@media screen and (max-width: 860px) {
  .nav-links.responsive {
    position: relative;
    display: block;
  }

  /* .nav-logo.responsive a.icon {
    position: absolute;
    right: 0;
    top: 0;
  } */

  .nav-links.responsive a {
    float: none;
    display: block;
    text-align: left;
    border-bottom: 1px solid #dcdfe6;
    margin-right: 20vw;
    width: 30vw;
  }

  .nav-logo.responsive {
    float: none;
    display: block;
    text-align: left;
    border-bottom: 1px solid #dcdfe6;
  }

  .nav-btns.responsive {
    float: none;
    display: block;
    text-align: left;
  }

  .nav-btns.responsive .nav-btn {
    float: left;
    text-align: left;
    display: block;
    padding: 14px 16px;
    margin-left: 10px;
    margin-bottom: 10px;
  }

  .nav-links {
    padding-top: 0px;
  }

  .nav-access.responsive {
    position: absolute;
    top: 2.3vh;
    right: 17vw;
    float: none;
    text-align: left;
    /* float: left; */
    display: block;
  }

  #btn-language.responsive span {
    display: none;
  }
}
</style>
